import type {
  CommentRequestAPIAction,
  CommentRequestAPIPayload,
  CommentRestoreRequestAPIPayload,
  ReplyCommentRequestAPIAction,
  ReplyCommentRequestAPIPayload,
} from './types';

export const COMMENT_REQUEST_API = 'COMMENT_REQUEST_API';
export const COMMENT_REPLY_REQUEST_API = 'COMMENT_REPLY_REQUEST_API';
export const RESTORE_COMMENT_REQUEST_API = 'RESTORE_COMMENT_REQUEST_API';

export const commentRequestAPI = (
  params: CommentRequestAPIPayload,
): CommentRequestAPIAction => {
  return {
    type: COMMENT_REQUEST_API,
    params,
  };
};

export const commentReplyRequestAPI = (
  params: ReplyCommentRequestAPIPayload,
): ReplyCommentRequestAPIAction => {
  return {
    type: COMMENT_REPLY_REQUEST_API,
    params,
  };
};

export const commentRestoreRequestAPI = (
  params: CommentRestoreRequestAPIPayload,
) => {
  return {
    type: RESTORE_COMMENT_REQUEST_API,
    params,
  };
};
